var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-form-button"},[_c('a-button',{staticClass:"cancel-button",attrs:{"shape":"round"},on:{"click":function($event){return _vm.$emit('onCancel')}}},[_vm._v(" 返回 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }